import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { isMobileContext } from "../context/isMobileContext";
import { motion } from "framer-motion";

export default function Banner({ bannerData, uniqueClass,environmentPage }) {
	const { isMobile } = useContext(isMobileContext);
	const { t } = useTranslation();

	return (
		<div className={`achievements-banner ${uniqueClass}`}>
			<div className="info">
				<div className="header"> 
					<div className="second-container">
						<motion.h2
							initial={{ opacity: 0, translateY: "95%" }}
							whileInView={{ opacity: 1, translateY: 0 }}
							viewport={{ once: true }}
							transition={{ ease: "easeInOut", duration: 0.7, delay: 0 }}
							className="second"
						>
							{bannerData.our} {" "}
							{bannerData.headline1}
						</motion.h2>
					</div>
					<div className="main-title-container">
						<motion.h1
							initial={{ opacity: 0, translateY: "95%" }}
							whileInView={{ opacity: 1, translateY: 0 }}
							viewport={{ once: true }}
							transition={{ ease: "easeInOut", duration: 0.7, delay: 0.2 }}
							className="main-title"
						>
							{bannerData.headline2}
						</motion.h1>
					</div> 
					{bannerData.worldClass &&
						<div className="world-class-container">
							<motion.h4
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 0.7 }}
							>
								{bannerData.worldClass}
							</motion.h4>
							{environmentPage&&<motion.h4
								initial={{ opacity: 0, translateY: "95%" }}
								whileInView={{ opacity: 1, translateY: 0 }}
								viewport={{ once: true }}
								transition={{ ease: "easeInOut", duration: 0.7, delay: 0.7 }}
							>
								{bannerData.worldClass1}
							</motion.h4>}
						</div>
					}
					{bannerData.description && !isMobile &&
						<motion.div
							initial={{ opacity: 0}}
							whileInView={{ opacity: 1}}
							viewport={{ once: true }}
							transition={{ ease: "easeInOut", duration: 0.7, delay: 1.2 }}
							className="desc">
							<p>{bannerData.description}</p>
						</motion.div>
					}
				</div>
			</div>
			<motion.div className="image-container"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				viewport={{ once: true }}
				transition={{ delay: 0.5, duration: 2 }}
			>
				<img
					src={process.env.PUBLIC_URL + bannerData.img}
					alt="home-banner-img"
				/>
			</motion.div>
			<motion.div className="backlayer-1"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				viewport={{ once: true }}
				transition={{ delay: 0, duration: 1 }}
			>
				<img src={process.env.PUBLIC_URL + "/imgs/home-page/banner-back-layer1.svg"} alt="backlayer-1" />
			</motion.div>
			{/* <div className="backlayer-2">
            <img  src="/imgs/home-page/banner-back-layer2.svg" alt="backlayer-2" />
        </div> */}
		</div>
	);
}
